'use strict';
var optimizeCall = require('./optimizeCall');

var optimizeMouseMoveCall = optimizeCall();
document.body.addEventListener('mousemove', optimizeMouseMoveCall.call);

function dragDelegate(onMove, onEnd) {
    var startPosition;
    var delta;
    var isMoving = false;
    var onMoveProxy = function (e) {
        if (!startPosition) {
            startPosition = {
                pageX: e.pageX,
                pageY: e.pageY
            };
        }
        delta = {
            x: e.pageX - startPosition.pageX,
            y: e.pageY - startPosition.pageY
        };
        if (!isMoving) {
            if (Math.abs(delta.x) >= 5 || Math.abs(delta.y) >= 5) {
                isMoving = true;
            }
        }
        if (isMoving) {
            onMove(e, delta);
        }
    };
    var onEndProxy = function (e) {
        document.body.removeEventListener('mouseup', onEndProxy);
        optimizeMouseMoveCall.remove(onMoveProxy);
        onEnd(e, delta, isMoving);
    };
    document.body.addEventListener('mouseup', onEndProxy);
    optimizeMouseMoveCall.add(onMoveProxy);
}

module.exports = {
    dragDelegate: dragDelegate,
    onMove: function (cb) {
        optimizeMouseMoveCall.add(cb);
    },
    offMove: function (cb) {
        optimizeMouseMoveCall.remove(cb);
    }
};



/** WEBPACK FOOTER **
 ** ./src/helper/mouseHelper.js
 **/